import { render, staticRenderFns } from "./hard-disk-reports.vue?vue&type=template&id=4a47006c&scoped=true"
import script from "./hard-disk-reports.vue?vue&type=script&lang=js"
export * from "./hard-disk-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a47006c",
  null
  
)

export default component.exports